import BaseObject from "./BaseObject.js";
import appConfig from "../../config/app_config";

export default class TagsObject {
  static _objectDefinitionTagDef() {
    return {
      TagId: "",
      TagGroup: "",
      Description: "",
      Type: "Event",
      Owner: ""
    };
  }

  static _objectDefinition() {
    return {
      UserId: "",
      Owner: "",
      UserId: ""
    };
  }

  static _createRequestObjectForUser(
    userId,
    owner,
    includeTagRelation = false
  ) {
    const retObj = {
      Owner: owner,
      UserId: userId,
      Type: "User"
    };
    if (includeTagRelation != false)
      retObj.IncludeTagRelation = includeTagRelation;

    return retObj;
  }

  static _createRequestObjectForEvent(
    userId,
    userGroup,
    eventId
  ) {
    // it will return tags associated to event
    // if (appConfig.test == true && userId == "") {
    //   userId = "WT8HBA7U";
    // }
    const retObj = {
      UserGroup: userGroup,
      UserId: userId,
      RelationType: "Event",
      Id: eventId
    };

    return retObj;
  }

  static _createRequestObjectForMessage(
    userId,
    userGroup,
    messageId,
  ) {
    // it will return tags associated to message
    // if (appConfig.test == true && userId == "") {
    //   userId = "WT8HBA7U";
    // }

    const retObj = {
      UserGroup: userGroup,
      UserId: userId,
      Id: messageId,
      RelationType: 'Message'
    };

    return retObj;
  }

  static _createRequestObject(userId, userGroup, Id = null, relationType = 'Event') {
    const retObj = {
      UserGroup: userGroup,
      UserId: userId,
      RelationType: relationType,
    };
    if(Id != null)
      retObj.Id = Id;

    return retObj;
  }

  static _parseTagsData(data) {
    let outputArray = [];
    if (!data.hasOwnProperty("Tags")) return outputArray;

    return BaseObject._createArrayWithObjects(data.Tags);
  }

  static _createSaveTagDefRequest(object) {
    delete object.TagId;

    const retObj = {
      Description: object.Description,
      Owner: object.Owner,
      TagGroup: object.TagGroup,
      Type: object.Type
    };
    return retObj;
  }
}
